import * as React from 'react'
import { CheckboxProps } from './types'
import { StyledErrorMessage, StyledCheckbox, StyledLabel, StyledIndicator } from './styled'

export const Checkbox = ({
  variant = 'default',
  error = undefined,
  fill = 'white',
  label,
  disabled = false,
  ...rest
}: CheckboxProps) => {
  return (
    <>
      <StyledLabel variant={variant} hasError={!!error}>
        <StyledCheckbox type="checkbox" {...rest} />
        <StyledIndicator>
          <svg width="12" height="10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              fill={fill}
              d="M11.5.167a.833.833 0 0 1 .167 1.166l-6.25 8.334a.833.833 0 0 1-1.225.118L.442 6.4a.833.833 0 1 1 1.117-1.237L4.63 7.936 10.333.333A.833.833 0 0 1 11.5.167Z"
              fill-opacity={disabled ? '0.4' : undefined}
            />
          </svg>
        </StyledIndicator>
        <span>{label}</span>
      </StyledLabel>
      {error && <StyledErrorMessage>{error}</StyledErrorMessage>}
    </>
  )
}
